import PropTypes from 'prop-types';

import Heading from '@zenbusiness/zui/Heading';
import Slot from '@zenbusiness/zui/Slot';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import { zuiPropTypes } from '@zenbusiness/zui/utils/propTypes';
import { useSlotProps } from '@zenbusiness/zui/utils/useSlotProps';
import { useStableSlots } from '@zenbusiness/zui/utils/useStableSlots';

import BackButton from '#client/components/BackButton';
import useFlowNavigation from '#client/hooks/useFlowNavigation';

function PageHeader({
  disableBack,
  hideBack,
  slots: inSlots,
  slotProps: inSlotProps,
  subtitle,
  title
}) {
  const { prevPagePath } = useFlowNavigation();
  const { slots, slotProps } = useStableSlots(inSlots, inSlotProps);

  const Subtitle = slots.subtitle ?? Text;

  const subtitleProps = useSlotProps(Subtitle, slotProps.subtitle, {
    propsAdded: {
      component: 'p',
      size: 'sm'
    }
  });

  const hideBackButton = hideBack || !prevPagePath;

  return (
    <Stack component="header" gap={1}>
      {!hideBackButton && <BackButton disableBack={disableBack} />}
      <Stack gap={0.5} sx={{ marginBlockStart: hideBackButton ? { xs: 2, md: 3 } : 0 }}>
        <Heading component="h1" family="secondary" size="2xl" weight="bold">
          {title}
        </Heading>
        {subtitle && (
          <Slot component={Subtitle} props={subtitleProps}>
            {subtitle}
          </Slot>
        )}
      </Stack>
    </Stack>
  );
}

PageHeader.propTypes = {
  /** disable back button so it is unclickable */
  disableBack: PropTypes.bool,
  /** Remove the back button from displaying. */
  hideBack: PropTypes.bool,
  /** The slot props for the component. */
  slotProps: PropTypes.shape({
    /** The slot props for the subtitle slot container. */
    subtitle: zuiPropTypes.slotPropType
  }),
  /** The slots for the component. */
  slots: PropTypes.shape({
    /** The content to render in the subtitle slot. */
    subtitle: zuiPropTypes.slotType
  }),
  /** The page header subitlte. */
  subtitle: PropTypes.node,
  /** The page header title. */
  title: PropTypes.node
};

export default PageHeader;
